
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Ity dia nentin'ny
                    <a href="${0}">tetikasa Folksonomy Engine</a>. Aza
                    mandray anjara na manome hevitra`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Ity fitaovana ity dia ahafahanao manitsy ny lisitry ny akora. Azonao atao ny manampy, manala na manova
                lisitry ny akora.
                <br>
                Ity endri-tsoratra <span class="highlight">␣</span> ity dia maneho habaka.
                <br>
                Ity endri-tsoratra <span class="highlight">↩︎</span> ity dia maneho fiatoana andalana. `,
'hb28f1f2ec1744ee9': html`Ireo fananana ireo dia noforonina sy apetraky ny mpampiasa ho an'ny karazana fampiasana rehetra. Aza misalasala manampy ny anao
                    . Ny fananana sy ny soatoavina noforoninao
                    <strong>dia tsy maintsy ho tena zava-misy</strong>. Azonao atao ny mitsoraka ao amin'ny
                    <a href="${0}">ny lisitry ny fananana efa nampiasain'ny vondrom-piarahamonina</a>
                    na mijery ny antontan-taratasin'ny fananana
                    <a href="${1}">sy ny motera fikarohana azy</a>.`,
's000a5b76bd3a01c2': `Mametraka fananana...`,
's000d98595e959c1e': `Raiso ao amin'ny Google Play`,
's013bdc8cf0d3583d': `Ampio izahay amin'ny akora`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Hamarino ny vokatra`,
's03e9c8114521b998': `Hanova ny ingredient aho`,
's05ec315d9308091a': `Kisary zoro barcode`,
's061eb5af92512c85': `Voavonjy! Afaka manampy iray hafa ve ianao?`,
's06847c221c4c0bc1': `Te-hamorona fananana aho mba [hazavao ny tranga fampiasanao]...`,
's06f6c6f99db6b552': `tamin'ny fototra`,
's081e2ad82db71e1d': `Soatoavina voavondrona`,
's09205907b5b56cda': `Tsia`,
's0b4235aae602a950': `antontan-taratasy voatokana`,
's0bb2d48532acc455': `Misintona CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Tsy manankery ny sary`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Manafoana ny vokatra`,
's11a18a69b30b65ed': `Ampio izahay hamaha ny lesoka ao amin'ny lisitry ny akora`,
's1205d5f6fccf8e69': `Vidin'ny fananana`,
's15d64a0a6715285a': `Key vaovao`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Faritra fifantenana`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Ampio izahay hanitsy ny fampahalalana momba ny sakafo`,
's1e00019dc454872d': `Omeo anarana fananana amin'ny alàlan'ny toetran'ny anarana fananana azafady.`,
's1e49126af0935a5b': `Lisitry ny vokatra mampiasa ity fananana ity`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Ajanona`,
's2db7b654c0a9bde0': `Taratasy ny fananana`,
's300b3a6ee4e1252d': str`Lalao ratsy ${0}%`,
's33f786bb6b4f0cf4': `Vokany`,
's33f85f24c0f5f008': `Tehirizo`,
's34be4af4e8fec4ae': `Anontanio aloha ny fiaraha-monina`,
's36d86adc823cbfa6': `Alohan'ny hamoronana fananana vaovao dia resaho amin'ny fiarahamonina izany:`,
's3781d25aa51a736c': `Folksonomy Engine Documentation`,
's383ae4449428b61e': `Avereno ny vokatra`,
's39bcf88721a1e8ee': `Avereno ny safidy`,
's39e14e14300694c7': `Documentation sy Torolàlana`,
's3b430cfa5c1fe7f4': str`Taratasy momba ny ${0}`,
's3f4e4b52f230a892': `Kanvas sary`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Sandany`,
's422bba9636ce2489': `Sary afovoany`,
's42dd66b2441566fd': `Kisary afovoany`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Hanova habe`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Isan'ny vokatra`,
's4df2f533c0c1e7d0': `Fanaraha-maso sary`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Afindrao ny safidy`,
's4f751fb9b3ed766c': `Mamorona fananana vaovao`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Ampidiro ny anaran'ny fananana...`,
's55d7249883a98ca1': `momba ity fananana ity ao amin'ny Open Food Facts wiki`,
's565867d84c04aea2': `Toetran'ny sivana...`,
's5666afe5cd0166de': `Azafady amboary ny lesoka na ovao ny lahatsoratra alohan'ny hanamafisana`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Mametraka vokatra...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Ampio izahay hanitsy ny fampahalalana momba ny sakafo.`,
's5dd6f12783fca34f': `Ahitsio ny lisitry ny ingredient`,
's5e8250fb85d64c23': `Akaiky`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Ovaina`,
's66413c24dcf680e2': `Dingana`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Sary voatetika`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Lalao tsara ${0}%`,
's71a5c9f4b68ef4d4': `Manisa`,
's74cb3d66f6a668e1': `tahirin-kevitra`,
's787dd11bed0dc88a': `Hanova habe`,
's7ce4fd9430e80cea': `sandany`,
's801a05fa8e881f37': `Mianara bebe kokoa momba ny famoronana trano sy torolalana:`,
's8038273de2cf8b73': `Misafidiana faritra hopotehina azafady.`,
's839cc2908a5387f2': `Sivana barcode...`,
's86197dcf3e96af64': `Mikaroka sy karohy ny fananana efa misy`,
's8a63be30a129a59c': `Hanova ny habeny ambany`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Hanova habe ambony havanana`,
's8db84aa4bc949af2': `Manorata ny fananana vaovao`,
's8f839a03997a16d7': `Jereo ny vokatra`,
's901ae1e236ac45d3': `Fanafoanana ny famafana`,
's907f7a97c6b29425': `Tandremo fa mety ovaina ny modely angona. Ampiasao amin'ny risikao manokana.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingredients:`,
's9a7f60fce090ecaf': `Tsy nahavita nampiditra fananana. Andramo indray rahatrizay.`,
's9b87abd68fb9df45': `Tsy hita? Mamorona fanalahidy vaovao {value}`,
's9c0f52425fd2f07e': `Mety Tsy Mifanaraka`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Tsy misy isa azo`,
'sa548778b24054030': `Tadiavo ny fananana rehetra natolotry ny tetikasa Folksonomy Engine. Ireo fananana ireo dia manome metadata fanampiny sy hevitra momba ny vokatra ao amin'ny angon-drakitra Open Food Facts.`,
'sa63907958bd0ec4b': `Hanova ny habeny ambony havia`,
'sa95b4224f685a36a': `Akatona ny modal`,
'sab56a1d439576fd6': `Kisary soso-kevitra`,
'sac47ea2901d04c15': `Hanova ny habeny ambany havia`,
'sb125227d436c2925': `Mitadiava hevitra momba ny fanananao ao amin'ny angon-drakitra momba ny fananana efa misy:`,
'sb125568d43642e6f': `Valio ny fanontaniana momba ny vokatra.`,
'sb1c538e038f9b214': str`Mifanaraka tsara ${0}%`,
'sb28639570ff3b852': `lisitry ny fananana rehetra`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Raha vantany vao voamarinao fa tsy misy ny fanananao ary eken'ny vondrom-piarahamonina fa ilaina izany, dia mila mirakitra an-tsoratra voalohany ao amin'ny wiki ianao.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Tsy misy vokatra hita amin'ity fananana ity.`,
'sb7f72e4c8a2d3357': `Sanda sivana...`,
'sb8178320160f84ea': `Asehoy ny vokatra`,
'sbad7d2734149470b': `Hanamafy`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Efa voavaly ny hevitra rehetra! Misaotra anao nanampy!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Sanda mifanentana`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Ovay ny ambony`,
'sc1c08d0cbcc3bd24': `Tsy Mifanaraka`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Soso-kevitra fanamboarana`,
'sc681b137e8f604f7': `Hamafiso ny famafana`,
'sc6daf8a31883f8b9': `Afindrao sary`,
'sc895972c88d38ca5': `Folksonomy fananana`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `andalana`,
'scb3b0671d7b7f640': `Sanda vaovao`,
'scb489a1a173ac3f0': `Eny`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Miaraha amin'ny Slack Discussion`,
'scdb6cad0b92721bf': `Tsy misy fananana hita.`,
'scf23a05631f93732': `Hamafiso fafao`,
'scfed2f270ef6a3aa': `Mifidiana faritra`,
'sd1022bc1ef9204f7': `Sary azo zahana`,
'sd1077c055cf9ba6b': `Ampio izahay hanamarina ny lisitry ny ingredient amin'ny vokatra.`,
'sd698d21ddecba56b': `Hey! Azonao atao ny manampy anay hanatsara ny mombamomba ny vokatra amin'ny famaliana ireto ampahany manaraka ireto:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Jereo raha efa misy ny fananana`,
'sdbf806fefc584115': `Tokony hahita a`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Ampio izahay hanitsy ny tsipelina ny akora.`,
'sdca5deead576ceee': `Hanova habe havanana ambany`,
'sdcc2555c5dde524f': `Tena tianao hamafa ity singa ity tokoa ve ianao? Tsy azo averina io hetsika io.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `hanafoana`,
'se5127cf0f92e7e48': `Soso-kevitra: azonao atao koa ny mahita ny`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Hanolotra vokatra tsara kokoa aho`,
'seea3800e27baa686': `Vokatra tsirairay`,
'sefaba4adc4ec9219': `Folksonomy Properties`,
'seffa8ca49175b5f0': `Fananana manokana`,
'sf44a6b3b232c28ea': str`Soloy amin'ny ${0}ny sanda ankehitriny`,
'sf4cd86a2f5ef2588': `Barcode vokatra`,
'sf57a61152168cc81': `Ampio izahay hanitsy ny fitadiavana ingredient`,
'sf88b90b8ba23871c': `Lalao tsy fantatra`,
'sf9aee319a006c9b4': `Hanampy`,
'sfacbbe968fa7d773': `Anaran'ny fananana:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Sanda mifanentana`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  